import '../css/Scroll.css' ;
import React, { useEffect, useState } from 'react';
import Comp1 from '../img/C1.png'
import Comp2 from '../img/C2.png'
import Comp3 from '../img/C3.png'
import Comp4 from '../img/C4.png'

function HumanTest() {


    
  const [test, settest] = useState(true); 
  
  useEffect(() => {


    const options = {
        // null을 설정하거나 무엇도 설정하지 않으면 브라우저 viewport가 기준 .
        root: null,
        // 타겟 요소의 50%가 루트 요소와 겹치면 콜백을 실행
        threshold: 0.5

    };
       // Intersection Observer 인스턴스
        const observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                var tt = entry.target.children;
                // console.log('하위 갯수' + entry.target.children[0].target.classList.add('te'))
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv_active');
                    console.log('Add active')

                    // 지연 로딩이 실행되면 unobserve 해준다.
                    // observer.unobserve(entry.target)
                }
                else {
                    //  entry.target.classList.remove('testDiv_active');
                    console.log('벗어남')
                }
            })
        }, options)


        const ims = document.querySelectorAll(".personnel_Benefits")

        ims.forEach(img =>
            observer.observe(img)
        );

      }, [])






    return (
        <div>
             <div class='personnel_Benefits2'>
                    <div class='personnel_BenefitContent2' style={{ borderColor : "#e6e6e6"}}>

                    <div className='PB_container'>
                     <img className='personnel_BenefitContentImg' src={Comp1} />
                     <p className='BenefitContent_Subject'>사내문화</p>
                    </div>
                    <p className='BenefitContent_Expl'>유연 근무제, 기숙사 제공, 사내 동호회 활동비지원, 장기근속 포상, 자율복장</p>

                    </div>

                    <div class='personnel_BenefitContent2' style={{ borderColor : "#e6e6e6"}}>

<div className='PB_container'>
 <img className='personnel_BenefitContentImg' src={Comp1} />
 <p className='BenefitContent_Subject'>사내문화</p>
</div>
<p className='BenefitContent_Expl'>유연 근무제, 기숙사 제공, 사내 동호회 활동비지원, 장기근속 포상, 자율복장</p>

</div>


<div class='personnel_BenefitContent2' style={{ borderColor : "#e6e6e6"}}>

<div className='PB_container'>
 <img className='personnel_BenefitContentImg' src={Comp1} />
 <p className='BenefitContent_Subject'>사내문화</p>
</div>
<p className='BenefitContent_Expl'>유연 근무제, 기숙사 제공, 사내 동호회 활동비지원, 장기근속 포상, 자율복장</p>

</div>


<div class='personnel_BenefitContent2' style={{ borderColor : "#e6e6e6"}}>

<div className='PB_container'>
 <img className='personnel_BenefitContentImg' src={Comp1} />
 <p className='BenefitContent_Subject'>사내문화</p>
</div>
<p className='BenefitContent_Expl'>유연 근무제, 기숙사 제공, 사내 동호회 활동비지원, 장기근속 포상, 자율복장</p>

</div>
             </div>


             <div class='personnel_BenefitContent2' style={{ borderColor : "#e6e6e6"}}>

<div className='PB_container'>
 <img className='personnel_BenefitContentImg' src={Comp1} />
 <p className='BenefitContent_Subject'>사내문화</p>
</div>
<p className='BenefitContent_Expl'>유연 근무제, 기숙사 제공, 사내 동호회 활동비지원, 장기근속 포상, 자율복장</p>

</div>


<div class='personnel_BenefitContent2' style={{ borderColor : "#e6e6e6"}}>

<div className='PB_container'>
 <img className='personnel_BenefitContentImg' src={Comp1} />
 <p className='BenefitContent_Subject'>사내문화</p>
</div>
<p className='BenefitContent_Expl'>유연 근무제, 기숙사 제공, 사내 동호회 활동비지원, 장기근속 포상, 자율복장</p>

</div>

<div class='personnel_BenefitContent2' style={{ borderColor : "#e6e6e6"}}>

<div className='PB_container'>
 <img className='personnel_BenefitContentImg' src={Comp1} />
 <p className='BenefitContent_Subject'>사내문화</p>
</div>
<p className='BenefitContent_Expl'>유연 근무제, 기숙사 제공, 사내 동호회 활동비지원, 장기근속 포상, 자율복장</p>

</div>

<div class='personnel_BenefitContent2' style={{ borderColor : "#e6e6e6"}}>

<div className='PB_container'>
 <img className='personnel_BenefitContentImg' src={Comp1} />
 <p className='BenefitContent_Subject'>사내문화</p>
</div>
<p className='BenefitContent_Expl'>유연 근무제, 기숙사 제공, 사내 동호회 활동비지원, 장기근속 포상, 자율복장</p>

</div>

<div class='personnel_BenefitContent2' style={{ borderColor : "#e6e6e6"}}>

<div className='PB_container'>
 <img className='personnel_BenefitContentImg' src={Comp1} />
 <p className='BenefitContent_Subject'>사내문화</p>
</div>
<p className='BenefitContent_Expl'>유연 근무제, 기숙사 제공, 사내 동호회 활동비지원, 장기근속 포상, 자율복장</p>

</div>


<div class='personnel_BenefitContent2' style={{ borderColor : "#e6e6e6"}}>

<div className='PB_container'>
 <img className='personnel_BenefitContentImg' src={Comp1} />
 <p className='BenefitContent_Subject'>사내문화</p>
</div>
<p className='BenefitContent_Expl'>유연 근무제, 기숙사 제공, 사내 동호회 활동비지원, 장기근속 포상, 자율복장</p>

</div>

<div class='personnel_BenefitContent2' style={{ borderColor : "#e6e6e6"}}>

<div className='PB_container'>
 <img className='personnel_BenefitContentImg' src={Comp1} />
 <p className='BenefitContent_Subject'>사내문화</p>
</div>
<p className='BenefitContent_Expl'>유연 근무제, 기숙사 제공, 사내 동호회 활동비지원, 장기근속 포상, 자율복장</p>

</div>





            <div class='personnel_Benefits'>
                <div class='personnel_BenefitContent' style={{ borderColor : "#e6e6e6"}}>

                    <div className='PB_container'>
                     <img className='personnel_BenefitContentImg' src={Comp1} />
                     <p className='BenefitContent_Subject'>사내문화</p>
                    </div>
                    <p className='BenefitContent_Expl'>유연 근무제, 기숙사 제공, 사내 동호회 활동비지원, 장기근속 포상, 자율복장</p>

                </div>

                <div class='personnel_BenefitContent' style={{ borderColor : "#e6e6e6"}}>

                  <div className='PB_container'>
                   <img className='personnel_BenefitContentImg' src={Comp2} />
                   <p className='BenefitContent_Subject'>의료 지원</p>
                  </div>
                  <p className='BenefitContent_Expl'>의료비 지원, 종합검진비 지원, 단체상해보험, 모성보호실 운영</p>

                </div>

                <div class='personnel_BenefitContent' style={{ borderColor : "#e6e6e6"}}>

                    <div className='PB_container'>
                     <img className='personnel_BenefitContentImg' src={Comp3} />
                     <p className='BenefitContent_Subject'>생활 지원</p>
                    </div>
                    <p className='BenefitContent_Expl'>경조사 지원, 학자금 지원, 주택대부금 지원</p>

                </div>
          
          
                <div class='personnel_BenefitContent' style={{ borderColor : "#e6e6e6"}}>

                    <div className='PB_container'>
                     <img className='personnel_BenefitContentImg' src={Comp4} />
                     <p className='BenefitContent_Subject'>자기 개발 지원</p>
                    </div>
                    <p className='BenefitContent_Expl'>어학 시험 비용 지원, 품질 검사원 국제 자격증 갱신비 지원</p>

                </div>
            </div>
        </div>
    );
}

export default HumanTest;